import { gql } from '@apollo/client';

export interface Program {
  uuid?: string;
  id: string;
  name?: string;
  programKind?: string;
  academicPartner?: {
    academicModel: string;
  };
  studentFacingAcademicPartner?: {
    uuid?: string;
    name?: string;
    link?: string;
    logoAltText?: string;
    colorLogoUrl?: string;
    informalName?: string;
    logos?: {
      color: string;
    };
  };
}

export interface ProgramsByUuidResponse {
  programs: Program[];
}

export interface ProgramsByUuidVariables {
  programUuids?: string[];
}

export const GET_PROGRAM_BY_UUID = gql`
  query GET_PROGRAM_BY_UUID($programUuid: ID!) {
    programUuid(programUuid: $programUuid) {
      id
      name
      studentFacingAcademicPartner {
        uuid
        name
        link
        logoAltText
        colorLogoUrl
        academicModel
        informalName
        logos {
          color
        }
      }
    }
  }
`;

export const GET_PROGRAMS_BY_UUID = gql`
  query GET_PROGRAMS_BY_UUID($programUuids: [ID!]) {
    programs(programUuids: $programUuids) {
      uuid
      id
      name
      programKind
      academicPartner {
        academicModel
      }
      studentFacingAcademicPartner {
        uuid
        name
        logoAltText
        colorLogoUrl
        academicModel
        informalName
        logos {
          color
        }
      }
    }
  }
`;
